<app-nav-admin--menu></app-nav-admin--menu>

<div class="configContent">
  <h1 class="configTitle">Duration Steps</h1>

  <div class="row mb-4">
    <mat-form-field class="col-3">
      <mat-label>Country</mat-label>
      <mat-select [(value)]="countryId" (selectionChange)="onCountryChanged($event)" [disabled]="dirty">
        <mat-option *ngFor="let c of countries" [value]="c.id">
          {{c.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="col-3">
      <mat-label>Protection Type</mat-label>
      <mat-select [(value)]="protectionTypeId" (selectionChange)="onProtectionTypeChanged($event)" [disabled]="dirty">
        <mat-option *ngFor="let p of protectionTypes" [value]="p.id">
          {{p.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="col-3">
      <mat-label>Filing Route</mat-label>
      <mat-select [(value)]="filingRouteId" (selectionChange)="onFilingRouteChanged($event)" [disabled]="dirty">
        <mat-option *ngFor="let f of filingRoutes" [value]="f.id">
          {{f.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="col-3">
      <mat-label>Technical Fields</mat-label>
      <mat-select [(value)]="technicalFieldId" (selectionChange)="onTechnicalFieldChanged($event)" [disabled]="dirty">
        <mat-option *ngFor="let f of technicalFields" [value]="f.id">
          {{f.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>


  <table class="table">
    <thead>
      <tr>
        <th>Type</th>
        <th>Name</th>
        <th>Group</th>
        <th class="durationColumn">Duration</th>
        <th class="unitColumn">Unit</th>
        <th class="costColumn">Official </th>
        <th class="costColumn">Professional </th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let step of stepDurationData; index as i">
        <td><p class="mt-2 mb-4" style="text-transform: capitalize">{{getStepTypeViewValue(step.type)}}</p></td>
        <td>{{step.name}}</td>
        <td>{{getDurationGroupName(step)}}</td>
        <td class="durationColumn">{{getDurationValue(step)}}</td>
        <td class="unitColumn">{{getDurationUnit(step)}}</td>
        <td class="costColumn">{{formatCost(step.cost)}}</td>
        <td class="costColumn">{{formatCost(step.professional)}}</td>
        <td class="actionsColumn">
          <button mat-icon-button (click)="moveStepUp(i)" [disabled]="i == 0" class="me-2"><mat-icon>keyboard_arrow_up</mat-icon></button>
          <button mat-icon-button (click)="moveStepDown(i)" [disabled]="i == (stepDurationData.length - 1)" class="me-4"><mat-icon>keyboard_arrow_down</mat-icon></button>
          <button mat-icon-button (click)="editStep(i, step)" class="me-2"><mat-icon>edit</mat-icon></button>
          <button mat-icon-button (click)="deleteStep(i)"><mat-icon>delete</mat-icon></button>
        </td>
      </tr>
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td class="addSteps">
          <button mat-icon-button (click)="addStep()"><mat-icon>add</mat-icon></button>
        </td>
      </tr>
    </tbody>
  </table>

  <hr />

  <div class="mb-5 buttonConfig">
    <button mat-raised-button class="me-2" (click)="save()" [disabled]="!dirty">Save</button>
    <button mat-raised-button (click)="discard()" [disabled]="!dirty">Discard Changes</button>
  </div>
</div>

<footer>
  <patempoFooter></patempoFooter>
</footer>
